import React from 'react';

import { ReactSVG } from 'react-svg';
import MiniPopUp from 'components/modal/miniPopUp';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Gap from 'components/gap';
import { formatDateTime } from 'common/helpers/format';
import { useActions } from 'common/hooks/useActions';
import { usePageTitle } from 'components/pageTitle';
import { handleDeleteToken } from '../../../../../firebase';

import * as S from './styles';

interface IProps {
  notifications: any;
  userInfo?: any;
  /** Flips the sidebar between full width and the icon-only rail. */
  onToggleSidebar?: () => void;
}

/**
 * Which corner of the product the current screen belongs to, read off the
 * route. Presentation only — it names the section beside the page title.
 */
const SECTIONS: Record<string, string> = {
  cafeteria: 'Cafeteria',
  ticket: 'Tickets',
  users: 'Users',
  location: 'Location',
  events: 'Events',
  reservation: 'Reservations',
  survey: 'Surveys',
  notifications: 'Notifications',
  news: 'News',
  access: 'Access'
};

const Header: React.FC<IProps> = ({ notifications, userInfo, onToggleSidebar }) => {
  const nav = useNavigate();
  const location = useLocation();
  const title = usePageTitle();
  const { notficationUpdateReadRequestAction, logOutRequestAction } = useActions();

  const handleLogout = () => {
    handleDeleteToken();
    logOutRequestAction(() => {});
    nav('/auth/login');
  };

  const goBack = () => {
    nav(-1);
  };

  const isHomePage = location.pathname === '/panel/dashboard';
  const section = SECTIONS[location.pathname.split('/')[2]];

  return (
    <S.HeaderContainer>
      <S.IconButton type="button" onClick={onToggleSidebar} title="Show or hide the navigation">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">
          <path d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </S.IconButton>

      {!isHomePage && (
        <S.IconButton type="button" onClick={goBack} title="Back">
          <ReactSVG src="/icons/arrow-back copy.svg" />
        </S.IconButton>
      )}

      <S.Title>{title}</S.Title>
      {section ? <S.Meta>{section}</S.Meta> : <></>}

      <S.InfoContainer>
        <MiniPopUp
          buttonNode={
            <S.IconBox
              className={notifications?.countUnread ? 'newNotif' : ''}
              onClick={() => notficationUpdateReadRequestAction({ readAll: true })}
              title="Notifications"
            >
              <ReactSVG src="/icons/fill/notif.svg" />
            </S.IconBox>
          }
          popUpStyle={{ width: 315, padding: 0 }}
        >
          <S.Notifications>
            <Gap size="16px" />

            <S.Grid style={{ padding: '0 16px' }}>
              <S.NotifTitle>Your notifications</S.NotifTitle>
              {notifications?.countUnread ? <S.NotifSpan>{notifications?.countUnread} new</S.NotifSpan> : <></>}
            </S.Grid>
            <Gap size="12px" />
            <S.NotifList>
              {notifications?.list?.map((item: any) => {
                return (
                  <S.NotifItem className={!item?.isRead ? 'unRead' : ''}>
                    <S.NotifItemTitle>{item?.title}</S.NotifItemTitle>
                    <S.NotifItemText>{item?.body}</S.NotifItemText>
                    <S.NotifDate>{formatDateTime(item?.createdAt)}</S.NotifDate>
                  </S.NotifItem>
                );
              })}
            </S.NotifList>
          </S.Notifications>
        </MiniPopUp>

        <MiniPopUp
          buttonNode={
            <S.ProfileHeader>
              <S.Image src="/images/default-avatar.jpg" alt="" />
              <S.ProfileTitle>{userInfo?.mail}</S.ProfileTitle>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path d="M6 9l6 6 6-6" />
              </svg>
            </S.ProfileHeader>
          }
          popUpStyle={{ width: 152 }}
        >
          <S.Ul>
            <S.Li onClick={handleLogout}>
              <Link to="#">Sign out</Link>
            </S.Li>
          </S.Ul>
        </MiniPopUp>
      </S.InfoContainer>
    </S.HeaderContainer>
  );
};

export default Header;
